import { ChevronDownIcon } from 'lucide-react-native';
import { type StyleProp, StyleSheet, type ViewStyle } from 'react-native';
import RNSelectDropdown from 'react-native-select-dropdown';
import { type TextProps, XStack } from 'tamagui';

import { useThemeColors } from '../../themes/SmoothieColorTokens';
import { Icon } from '../icons/Icon';
import { BodyMediumEmphasized } from '../text/Typography';

interface SelectDropdownProps {
    defaultValue?: string;
    options: string[];
    onSelect: (selectedItem: string, index: number) => void;
    buttonStyle?: StyleProp<ViewStyle>;
    buttonTextStyle?: TextProps;
    rowItemTextStyle?: TextProps;
    disabled?: boolean;
}

export const SelectDropdown = ({
    defaultValue,
    options,
    onSelect,
    buttonStyle,
    buttonTextStyle,
    rowItemTextStyle,
    disabled = false,
}: SelectDropdownProps) => {
    const { getColor } = useThemeColors();
    return (
        <RNSelectDropdown
            data={options}
            onSelect={onSelect}
            defaultValue={defaultValue}
            rowTextForSelection={(item, _) => {
                return item as string;
            }}
            buttonStyle={{
                width: '100%',
                borderRadius: 12,
                backgroundColor: getColor('$white'),
                paddingRight: 16,
                ...(StyleSheet.flatten(buttonStyle) ?? {}),
            }}
            dropdownStyle={{
                height: 'auto',
                padding: 8,
                borderRadius: 12,
                backgroundColor: getColor('$white'),
            }}
            disabled={disabled}
            rowStyle={{
                borderRadius: 8,
                padding: 8,
                borderBottomWidth: 0,
            }}
            selectedRowStyle={{
                backgroundColor: getColor('$gray100'),
            }}
            renderCustomizedButtonChild={(item, _) => {
                return (
                    <XStack alignItems="center" justifyContent="space-between">
                        <BodyMediumEmphasized
                            {...(StyleSheet.flatten(buttonTextStyle) ?? {})}
                        >
                            {item}
                        </BodyMediumEmphasized>
                        {!disabled && (
                            <Icon
                                icon={ChevronDownIcon}
                                size={16}
                                color="$gray1200"
                            />
                        )}
                    </XStack>
                );
            }}
            renderCustomizedRowChild={(item, _) => {
                return (
                    <XStack>
                        <BodyMediumEmphasized
                            {...(StyleSheet.flatten(rowItemTextStyle) ?? {})}
                        >
                            {item}
                        </BodyMediumEmphasized>
                    </XStack>
                );
            }}
        />
    );
};
